import { useMemo } from "react";

export function useBroadcastChannel(name: string) {
  const channel = useMemo(() => {
    return new BroadcastChannel(name);
  }, [name]);
  return channel;
}
